import { render } from "./UserPlanList.vue?vue&type=template&id=7c6b4856&scoped=true"
import script from "./UserPlanList.vue?vue&type=script&lang=js"
export * from "./UserPlanList.vue?vue&type=script&lang=js"

import "./UserPlanList.vue?vue&type=style&index=0&id=7c6b4856&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6b4856"]])

export default __exports__